import { MouseEvent, ReactElement } from 'react';

import Table from '@/common/Table';
import { ImportHistorySortColumn } from './useImportHistoryTableSorting';
import useImportHistoryTableSorting from './useImportHistoryTableSorting';
import { SortDirectionEnum } from '@/models/gen/graphql';

const toTableDirection = (dir: SortDirectionEnum | undefined): 'asc' | 'desc' | undefined => {
  if (dir === SortDirectionEnum.Asc) return 'asc';
  if (dir === SortDirectionEnum.Desc) return 'desc';
  return undefined;
};

const ImportHistoryTableHeader = (): ReactElement => {
  const { column, direction, handleSort } = useImportHistoryTableSorting(({ state }) => state);

  const makeSortable = (
    col: ImportHistorySortColumn
  ): { direction: 'asc' | 'desc' | undefined; onSort: (event: MouseEvent<HTMLTableCellElement>) => void } => ({
    direction: column === col ? toTableDirection(direction) : undefined,
    onSort: handleSort(col),
  });

  return (
    <Table.Row header>
      <Table.Cell className="DATE alternate" sorting={makeSortable(ImportHistorySortColumn.IngestStarted)}>
        Date
      </Table.Cell>
      <Table.Cell className="TYPE" sorting={makeSortable(ImportHistorySortColumn.Type)}>
        Type
      </Table.Cell>
      <Table.Cell className="NAME alternate">Name</Table.Cell>
      <Table.Cell className="PROVIDER" sorting={makeSortable(ImportHistorySortColumn.ProviderDisplayName)}>
        Provider
      </Table.Cell>
      <Table.Cell className="FILENAME alternate" sorting={makeSortable(ImportHistorySortColumn.Filename)}>
        File Name
      </Table.Cell>
      <Table.Cell className="IMPORTED-BY" sorting={makeSortable(ImportHistorySortColumn.ImportedBy)}>
        Import By
      </Table.Cell>
      <Table.Cell className="TOTAL" sorting={makeSortable(ImportHistorySortColumn.Total)}>
        Total
      </Table.Cell>
      <Table.Cell className="CREATED" sorting={makeSortable(ImportHistorySortColumn.Created)}>
        Created
      </Table.Cell>
      <Table.Cell className="UPDATED" sorting={makeSortable(ImportHistorySortColumn.Updated)}>
        Updated
      </Table.Cell>
      <Table.Cell className="DELETED" sorting={makeSortable(ImportHistorySortColumn.Deleted)}>
        Deleted
      </Table.Cell>
      <Table.Cell className="UNCHANGED alternate" sorting={makeSortable(ImportHistorySortColumn.Unchanged)}>
        Unchanged
      </Table.Cell>
      <Table.Cell className="ACTIONS">
        <div className="ImportHistoryTableHeader-Actions d-flex w-100">
          <div className="ImportHistoryTableHeader-Download" style={{ overflow: 'hidden', width: 'calc(100% / 2)' }}>
            Download
          </div>
          <div className="ImportHistoryTableHeader-Delete" style={{ overflow: 'hidden', width: 'calc(100% / 2)' }}>
            Delete
          </div>
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

export default ImportHistoryTableHeader;
